var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{attrs:{"src":"static/output.html","width":"100%","height":"850","frameborder":"0","id":"testFrame"}})
}
var staticRenderFns = []

export { render, staticRenderFns }